import { render, staticRenderFns } from "./DmtKits.vue?vue&type=template&id=f3e70b60&"
import script from "./DmtKits.vue?vue&type=script&lang=js&"
export * from "./DmtKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports